import { createSlice } from '@reduxjs/toolkit'
import { DropoffState } from './types'

const initialState: DropoffState = {
  isDropoffFilterApplied: false,
  dropoffFilterData: {
    pickUpLocation: '',
    dropOffLocation: '',
  },
}

export const dropoffSlice = createSlice({
  name: 'dropoff',
  initialState,
  reducers: {
    setIsDropoffFilterApplied(state, action) {
      state.isDropoffFilterApplied = action.payload
    },
    setDropoffFilterData(state, action) {
      state.dropoffFilterData = action.payload
    },
  },
})

export const dropoffReducer = dropoffSlice.reducer
export const { setIsDropoffFilterApplied, setDropoffFilterData } =
  dropoffSlice.actions
